<div class="row">
    <div class="col-md-12">
        <fi-map *ngIf="pageReady" [config]="config" (mapReady)="onMapReady($event)"></fi-map>
    </div>
</div>